// src/scene/camera.ts
import * as THREE from 'three';

/** Vertical FOV tuned for a wide desktop window. */
export const BASE_FOV = 62;

/** Aim to keep at least this much *horizontal* FOV on portrait screens. */
const TARGET_HFOV = 74;

/** Hard cap on vertical FOV — beyond this the edge works fisheye-distort. */
const MAX_FOV = 78;

/** Vertical FOV for a given viewport. Landscape keeps {@link BASE_FOV}; on a
 *  portrait (mobile) screen the horizontal frustum is narrow, so we widen the
 *  vertical FOV to recover some width — fewer sideways pans to cross the tall
 *  wall — clamped to {@link MAX_FOV} so the perspective doesn't go fisheye. */
export function fovForViewport(width: number, height: number): number {
  const aspect = width / height;
  if (aspect >= 1) return BASE_FOV; // landscape / square: unchanged
  const vFov = 2 * Math.atan(Math.tan(THREE.MathUtils.degToRad(TARGET_HFOV) / 2) / aspect);
  return THREE.MathUtils.clamp(THREE.MathUtils.radToDeg(vFov), BASE_FOV, MAX_FOV);
}
